import { useQuery } from '@tanstack/react-query';
import { taskResponsibilitiesAPI } from '../api/task-responsibilities.api';
import type { ResponsibilityFilters } from '../types';

export const useTaskResponsibilities = (filters?: ResponsibilityFilters) => {
  return useQuery({
    queryKey: ['task-responsibilities', filters],
    queryFn: async () => {
      const response = await taskResponsibilitiesAPI.getResponsibilities(filters);
      if (response.success) {
        return response.data || [];
      }
      throw new Error(response.message || 'Failed to fetch task responsibilities');
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false
  });
};

export const useEligibleUsers = (roles?: string[]) => {
  return useQuery({
    queryKey: ['eligible-users', roles],
    queryFn: async () => {
      const response = await taskResponsibilitiesAPI.getEligibleUsers(roles);
      if (response.success) {
        return response.data || [];
      }
      throw new Error(response.message || 'Failed to fetch eligible users');
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false
  });
};
